"use client";

import { useLayoutEffect, useRef } from "react";

export const VIEW_AS_BANNER_HEIGHT_VAR = "--view-as-banner-height";

function reserve(height: number) {
  document.documentElement.style.setProperty(VIEW_AS_BANNER_HEIGHT_VAR, `${height}px`);
  document.body.style.paddingBottom = `var(${VIEW_AS_BANNER_HEIGHT_VAR})`;
}

function release() {
  document.documentElement.style.removeProperty(VIEW_AS_BANNER_HEIGHT_VAR);
  document.body.style.removeProperty("padding-bottom");
}

export function useReservedBannerSpace<Element extends HTMLElement>(active: boolean) {
  const ref = useRef<Element>(null);

  useLayoutEffect(() => {
    const banner = ref.current;
    if (!active || !banner) return;
    reserve(banner.getBoundingClientRect().height);
    const observer =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(() => reserve(banner.getBoundingClientRect().height));
    observer?.observe(banner);
    return () => {
      observer?.disconnect();
      release();
    };
  }, [active]);

  return ref;
}
